// ======================================================================
// File Name       : ContentQuestionUtils
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export function sortAnswerByCorrectNumbers(answerInfo) {
  const check = Object.prototype.toString.call(answerInfo) === '[object Array]';
  if (check) {
    answerInfo = answerInfo.sort((a, b) => {
      if (a.correctAnswerNumber < b.correctAnswerNumber) {
        return -1;
      } else if (a.correctAnswerNumber > b.correctAnswerNumber) {
        return 1;
      }
      return 0;
    });
    return answerInfo;
  }
  return [];
}

export function createAttributeQuestionOptions(allSecernIds, bySecernId) {
  const data = [{ name: null, value: null }];
  if (allSecernIds && bySecernId) {
    allSecernIds.map((questionAttributeId) => {
      const secernId = bySecernId[questionAttributeId];
      const { questionAttributeName } = secernId;
      data.push({ name: questionAttributeName, value: questionAttributeId });
    });
  }
  return data;
}

export function createAttributionList(number) {
  const userAttributeList = [];
  for (let i = 1; i <= number; i++) {
    userAttributeList.push(`attribute${i}`);
  }
  return userAttributeList;
}

export function checkPreviewDetailQuestionPath(pathToCheck) {
  const realPathName = window.location.pathname.split('/');
  realPathName.splice(-2, 1, ':id');
  const realPathToCheck = realPathName.join('/');
  return realPathToCheck === pathToCheck;
}
